import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Trash2, Plus } from "lucide-react";

const RANDOM_COLORS = [
  "#F59E0B", "#94A3B8", "#B45309", "#3B82F6",
  "#10B981", "#EC4899", "#A855F7", "#EF4444",
];

export default function TierEditor({ tiers, onChange }) {
  const setTier = (idx, patch) => {
    const next = tiers.map((t, i) => (i === idx ? { ...t, ...patch } : t));
    onChange(next);
  };

  const addTier = () => {
    const id = (Math.random().toString(36) + Date.now().toString(36)).slice(2);
    onChange([
      ...tiers,
      {
        id,
        name: "New Tier",
        color: RANDOM_COLORS[tiers.length % RANDOM_COLORS.length],
        price: 100,
        duration_multiplier: 1,
      },
    ]);
  };

  const removeTier = (idx) => {
    onChange(tiers.filter((_, i) => i !== idx));
  };

  return (
    <div className="space-y-3" data-testid="tier-editor">
      <div className="flex items-center justify-between">
        <div className="label-eyebrow">Tier levels</div>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={addTier}
          data-testid="add-tier-btn"
          className="h-7 text-zinc-300 hover:text-zinc-50 hover:bg-zinc-800"
        >
          <Plus className="w-3 h-3 mr-1" /> Add
        </Button>
      </div>

      <div className="space-y-2">
        {tiers.map((t, i) => (
          <div
            key={t.id}
            data-testid={`tier-row-${i}`}
            className="grid grid-cols-12 gap-2 items-center bg-zinc-950 border border-zinc-800 rounded-md p-2"
            style={{ borderLeft: `4px solid ${t.color}` }}
          >
            <Input
              data-testid={`tier-name-${i}`}
              value={t.name}
              onChange={(e) => setTier(i, { name: e.target.value })}
              className="col-span-4 bg-zinc-900 border-zinc-800 h-8 text-sm"
              placeholder="Gold"
            />
            <div className="col-span-2 flex items-center gap-1">
              <input
                data-testid={`tier-color-${i}`}
                type="color"
                value={t.color}
                onChange={(e) => setTier(i, { color: e.target.value })}
                className="w-8 h-8 bg-transparent border border-zinc-800 rounded cursor-pointer"
              />
            </div>
            <Input
              data-testid={`tier-price-${i}`}
              type="number"
              min={0}
              step={1}
              value={t.price}
              onChange={(e) => setTier(i, { price: parseFloat(e.target.value || 0) })}
              className="col-span-3 bg-zinc-900 border-zinc-800 h-8 text-sm"
              placeholder="500"
            />
            <Input
              data-testid={`tier-multi-${i}`}
              type="number"
              min={0.1}
              step={0.1}
              value={t.duration_multiplier}
              onChange={(e) => setTier(i, { duration_multiplier: parseFloat(e.target.value || 1) })}
              className="col-span-2 bg-zinc-900 border-zinc-800 h-8 text-sm"
              placeholder="2.0"
            />
            <button
              type="button"
              data-testid={`tier-remove-${i}`}
              onClick={() => removeTier(i)}
              className="col-span-1 text-zinc-500 hover:text-red-400 grid place-items-center"
            >
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-12 gap-2 px-2 text-[10px] uppercase tracking-widest text-zinc-500">
        <div className="col-span-4">Name</div>
        <div className="col-span-2">Color</div>
        <div className="col-span-3">Price $</div>
        <div className="col-span-2">Duration ×</div>
      </div>
    </div>
  );
}
